module.exports = __webpack_public_path__ + "static/vestido-home-e0319db85fa090d0fb8cf102969b79aa.png";